import { IEnvironment } from './environment.interface';

/**
 * Everything that is common to all environment types.
 */
export const commonEnvironment: Omit<IEnvironment, 'environment'> = {
  version: '0.0.0',
  agGridLicenseKey:
    // eslint-disable-next-line max-len
    'Using_this_{AG_Grid}_Enterprise_key_{AG-098113}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{JOVACO_Solutions_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{25_May_2027}____[v3]_[01]_MTgxMTE5OTYwMDAwMA==3aed5e5e41f4449617fafb85c4eb5324'
};
